window.addEventListener('load', function() {
  $('.mxpr-review__list-item-image').each(function(index) {
    $(this).appendTo($(this).closest('.mxpr-review__list-item'));
  });
  $('.mxpr-review__list-item-createdat').each(function(index) {
    $(this).insertBefore($(this).closest('.mxpr-review__list-item').find('.mxpr-review__list-item-meta-title'));
  });
});

window.addEventListener('load', function() {
  $(document).ready(function() {
    $('#mxpr-summary__order-select').on('change', function() {
      setTimeout(function() {
        var interval = setInterval(function() {
          var listDisplayStyle = $('.mxpr-review__list').css('display');
          if (listDisplayStyle !== 'none') {
            $('.mxpr-review__list-item-image').each(function(index) {
              $(this).appendTo($(this).closest('.mxpr-review__list-item'));
            });

            clearInterval(interval);
          }
        }, 100);
      }, 1000);
    });
  });
});